import React from 'react';
import { useTranslation } from 'react-i18next';
import { useUserGroupsList } from '@modules/users/hooks/useUserGroupsList';
import LoadingButton from '@shared/components/LoadingButton';

export default function UserGroupsList({ onClose, onSave, groupData }) {
    const { t } = useTranslation();
    const {
        allGroups,
        selectedGroups,
        loading,
        saving,
        error,
        modalRef,
        handleGroupToggle,
        handleSave
    } = useUserGroupsList(onClose, onSave, groupData);

    if (loading) {
        return (
            <div className="modal show">
                <div className="form-wrapper top-20 width-50">
                    <div className="loading">{t('common.loading')}</div>
                </div>
            </div>
        );
    }

    return (
        <div className="modal show" tabIndex="-1">
            <div className="form-wrapper top-20 width-50" ref={modalRef}>
                <form className="form">
                    <h2 className="title">{t('users.groupTitle')}</h2>
                    
                    {error && <div className="error-message">{error}</div>}
                    
                    <div className="form-container">
                        <div className="form-data-container">
                            <div className="form-column">
                                <div className="form-input-wrapper">
                                    <div className="groups-list">
                                        {allGroups.map(group => (
                                            <div key={group.id} className="group-item">
                                                <label className="checkbox-label">
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedGroups.includes(group.id)}
                                                        onChange={() => handleGroupToggle(group.id)}
                                                    />
                                                    <span>{group.name}</span>
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="form-controls-container">
                        <LoadingButton 
                            className="form-btn btn-blue"
                            onClick={handleSave}
                            loading={saving}
                        >
                            {t('common.save')}
                        </LoadingButton>
                        <button
                            type="button"
                            className="form-btn btn-red"
                            onClick={onClose}
                            disabled={saving}
                        >
                            {t('common.cancel')}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
